import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import { Checkbox } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { DelegateContext } from "@/types/modular-permissions.types";
import { HexString } from "@/types/general.types";
import useModularPermissionsManager from "@/features/mod-perms/hooks/useModularPermissions.hook";
import classNames from "classnames";
import BlessCheckbox from "@/features/mod-perms/components/checkbox/checkbox";

type Props = {
  label: string;
  permissionId: number;
  walletAddress: HexString;
  isAllPermissionsToggle?: boolean;
  isPermModified?: boolean;
  isChecked: boolean;
};

const PermissionCheckbox = ({
  label,
  permissionId,
  walletAddress,
  isAllPermissionsToggle = false,
  isPermModified = false,
  isChecked,
}: Props) => {
  const { isAllPermissionsSelected, activeDelegateContext } =
    useModularPermissionsStore();

  const { handleCheckboxToggle } = useModularPermissionsManager();

  const isReceivedDelegate = activeDelegateContext === DelegateContext.Received;
  const isAllSelected = isAllPermissionsSelected(walletAddress);

  if (isAllPermissionsToggle)
    return (
      <div
        className={classNames(
          styles.checkbox,
          isPermModified && styles.isModified,
        )}
      >
        <BlessCheckbox
          className={styles.check}
          checked={isAllSelected}
          onChange={() =>
            handleCheckboxToggle(isAllSelected, walletAddress, permissionId)
          }
          disabled={isReceivedDelegate}
        />
        <span>{label}</span>
      </div>
    );
  else
    return (
      <div
        className={classNames(
          styles.checkbox,
          isPermModified && styles.isModified,
        )}
      >
        <BlessCheckbox
          disabled={
            isReceivedDelegate || isAllPermissionsSelected(walletAddress)
          }
          checked={isChecked || isAllSelected}
          onChange={() =>
            handleCheckboxToggle(isChecked, walletAddress, permissionId)
          }
        />
        <span>{label}</span>
      </div>
    );
};

export default PermissionCheckbox;
